import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_API_BASE_URL;
const API = `${BACKEND_URL}/api`;

/**
 * This page handles the ClickUp OAuth callback.
 * ClickUp redirects here with ?code=...&state=...
 * We call the backend to exchange the code for a token,
 * then redirect to the dashboard with a success flag.
 */
const ClickUpCallback = () => {
    const navigate = useNavigate();
    const [status, setStatus] = useState('Connecting your ClickUp account…');
    const [error, setError] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');

        if (!code || !state) {
            setError('Invalid callback — missing code or state.');
            setTimeout(() => navigate('/dashboard'), 3000);
            return;
        }

        // Call backend callback endpoint
        axios.get(`${API}/auth/clickup/callback`, { params: { code, state } })
            .then(() => {
                setStatus('ClickUp connected! Redirecting…');
                setTimeout(() => navigate('/dashboard?clickup_connected=1'), 1000);
            })
            .catch((err) => {
                const msg = err.response?.data?.detail || 'Failed to connect ClickUp.';
                setError(msg);
                setTimeout(() => navigate('/dashboard'), 3000);
            });
    }, []); // eslint-disable-line

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'Inter, sans-serif',
            background: '#f9fafb',
            gap: '16px'
        }}>
            {error ? (
                <>
                    <div style={{ fontSize: 40 }}>⚠️</div>
                    <p style={{ color: '#dc2626', fontWeight: 600 }}>{error}</p>
                    <p style={{ color: '#6b7280', fontSize: 14 }}>Redirecting you back…</p>
                </>
            ) : (
                <>
                    <div style={{
                        width: 40, height: 40, border: '3px solid #7c3aed',
                        borderTopColor: 'transparent', borderRadius: '50%',
                        animation: 'spin 0.8s linear infinite'
                    }} />
                    <p style={{ color: '#374151', fontWeight: 600 }}>{status}</p>
                    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                </>
            )}
        </div>
    );
};

export default ClickUpCallback;
